<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Advanced features' hidden needs
            </v-row>
            <!--table head-->
            <v-row class="subtitle-2" no-gutters>
                <v-col v-for="(item, i) in headers" :key="i" class="tabCell" :class="item.style">
                    {{ item.title }}
                </v-col>
            </v-row>
            <div v-if="advancedFeatures.length">
                <!--advanced features need tab-->
                <v-row v-for="af in advancedFeatures" :key="af.id" no-gutters>
                    <v-col class="tabCell text-truncate text-left">{{ af.segment?.name }}</v-col>
                    <v-col class="tabCell text-center">{{ af.positioning_need }}</v-col>
                    <v-col class="tabCell text-center">{{ af.power_bank_need }}</v-col>
                    <v-col class="tabCell text-center">{{ af.missed_items_warning_need }}</v-col>
                    <v-col class="tabCell text-center">{{ af.danger_alarm_need }}</v-col>
                    <v-col class="tabCell text-center">{{ af.fridge_camera_need }}</v-col>
                    <v-col class="tabCell text-center">{{ af.loss_insurance_need }}</v-col>
                    <v-col class="tabCell text-center">{{ af.friendly_utilization_need }}</v-col>
                    <v-col class="tabCell text-center">{{ af.profit_sharing_need }}</v-col>
                    <v-col class="tabCell text-center">{{ af.individual_pictures_need }}</v-col>
                    <v-col class="tabCell text-center">
                        <edit-feature :af="af" />
                        <delete-feature :af="af" />
                    </v-col>
                </v-row>
            </div>
            <v-row v-else class="mt-4" justify="center">
                there are no advanced features needs yet
            </v-row>
        </div>
        <!--!loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>

import EditFeature from '../../../components/admin/advanced-features/editAdvancedFeature.vue'
import DeleteFeature from '../../../components/admin/advanced-features/deleteAdvancedFeature.vue'
import Loader from '../../../layouts/Loader.vue'

export default {
    data() {
        return {
            headers: [
                { title: 'Segment name', style: 'text-left' },
                { title: 'Positioning tracker', style: 'text-center' },
                { title: 'Power bank', style: 'text-center' },
                { title: 'Missed items warning', style: 'text-center' },
                { title: 'Danger alarm', style: 'text-center' },
                { title: 'Fridge camera', style: 'text-center' },
                { title: 'Loss insurance', style: 'text-center' },
                { title: 'Environment friendly utilization', style: 'text-center' },
                { title: 'Charity profit sharing', style: 'text-center' },
                { title: 'Individual pictures', style: 'text-center' },
                { title: 'Actions', style: 'text-center' },
            ],
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        advancedFeatures() {
            return this.$store.getters.advancedFeatures;
        }
    },
    methods: {
    },
    components: {
        EditFeature,
        DeleteFeature,
        Loader
    }

}
</script>
